import checkout from './checkout';
import getCards from './get-cards';
import initialize from './initialize';
import initiateIdentityValidation from './initiate-identity-validation';
import unbindAppInstance from './unbind-app-instance';
//import isRecognized from './is-recognized';

export default {
  checkout,
  getCards,
  initialize,
  initiateIdentityValidation,
  unbindAppInstance
};
